import Vue from 'vue'
import VueRouter from  'vue-router'
import Search from '../components/Search.vue'
import Movie from '../components/Movie.vue'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';

Vue.use(VueFilterDateFormat);
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Search
  },
  // {
  //     name: 'movie',
  //     path: '/movies/:releaseYear/:slug',
  //     props: true,
  //     component: Movie
  // },  
]

const router = new VueRouter({
  mode: 'history',
  routes,
  // scrollBehavior (to, from, savedPosition) {
  //   console.log('scroll behav', to, from, savedPosition)
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
})

export default router